"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineFields = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const react_1 = tslib_1.__importDefault(require("react"));
const FormFields_1 = require("../FormFields");
const FieldWrapper = ({ field, parent, children }) => {
    const { direction, styles } = parent;
    return (react_1.default.createElement(components_1.View, { testID: "fieldTest", key: field.name, style: [styles && styles.fieldContainer, !direction && styles && styles.fieldContainerFill] }, children));
};
/**
 * A component that renders form actions, i.e. submit or reset buttons
 * @param props
 */
const InlineFields = (props) => {
    const { direction, style, styles = {} } = props;
    const stylesheet = [styles.root];
    if (direction === 'left') {
        stylesheet.push(styles.rootLeft);
    }
    else if (direction === 'right') {
        stylesheet.push(styles.rootRight);
    }
    stylesheet.push(style);
    return (react_1.default.createElement(components_1.View, { style: stylesheet, testID: "form-actions" },
        react_1.default.createElement(FormFields_1.FormFields, Object.assign({}, props, { FieldWrapper: FieldWrapper }))));
};
exports.InlineFields = InlineFields;
exports.InlineFields.displayName = 'InlineFields';
exports.InlineFields.defaultProps = {};
exports.InlineFields.defaultStyles = (theme) => ({
    fieldContainer: {
        margin: -theme.spacing.unit,
    },
    fieldContainerFill: {
        flex: 1,
    },
    root: {
        flexDirection: 'row',
        padding: theme.spacing.unit,
    },
    rootLeft: {
        justifyContent: 'flex-start',
    },
    rootRight: {
        justifyContent: 'flex-end',
    },
});
